import React, { useState, useEffect } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Services from './components/Services';
import Products from './components/Products';
import Industries from './components/Industries';
import About from './components/About';
import HowWeWork from './components/HowWeWork';
import CaseStudies from './components/CaseStudies';
import Testimonials from './components/Testimonials';
import Contact from './components/Contact';
import Footer from './components/Footer';
import './App.css';
import Client from './components/Client';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import DataEngineering from './pages/DataEngineering';
import DataScience from './pages/DataScience';
import GenAI from './pages/GenAI';
import Automation from './pages/Automation';
import AivionScore from './pages/Aivionscore';
import AivionSales from './pages/Aivionsales';
import AivionReach from './pages/Aivionreach';
import DigitalDeputee from './pages/Digitaldeputee';
import Financialservices from './pages/Financialservices';
import Education from './pages/Education';
import Healthcare from './pages/Healthcare';
import EnergyUtilities from './pages/EnergyUtilities';
import CreditRisk from './casestudies/creditrisk';
import ExamAssessment from './casestudies/examassessment';
import BloodBankManagement from './casestudies/bloodbankmanagement';
import FactCheckingReports from './casestudies/factcheckingreports';
import FinancialCrimeMonitoring from './casestudies/financialcrimemonitoring';
import GenAITutor from './casestudies/genaitutor';
import TheatreOptimisation from './casestudies/theatreoptimisation';
import GenerationForecasting from './casestudies/generationforecasting';
import SEO from './components/SEO';
import EngagementHub from './components/EngagementHub';
import LeadershipTeam from './components/LeadershipTeam';
import ProductResources from './components/ProductResources';
import PressNews from './components/PressNews';
import News from './pages/News';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};


function App() {
  const [theme, setTheme] = useState(() => {
    return localStorage.getItem('theme') || 'light';
  });

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    localStorage.setItem('theme', theme);
  }, [theme]);

  const toggleTheme = () => {
    setTheme(prev => prev === 'light' ? 'dark' : 'light');
  };

  return (
    <Router>
      <SEO />
      <ScrollToTop />
      <div className="App">
        <Navbar theme={theme} toggleTheme={toggleTheme} />

        <Routes>
          {/* Home route */}
          <Route path="/" element={
            <>
              <Hero />
              <Services />
              <Products />
              <ProductResources />
              <About />
              <LeadershipTeam />
              <EngagementHub />
              <PressNews />
              <Industries />
              <Client />
              <HowWeWork />
              <CaseStudies />
              <Testimonials />
              <Contact />
              <Footer />
            </>
          } />

          <Route path="/data-engineering" element={<DataEngineering />} />
          <Route path="/data-science" element={<DataScience />} />
          <Route path="/genai" element={<GenAI />} />
          <Route path="/automation" element={<Automation />} />
          <Route path="/aivionscore" element={<AivionScore />} />
          <Route path="/aivionsales" element={<AivionSales />} />
          <Route path="/aivionreach" element={<AivionReach />} />
          <Route path="/digitaldeputee" element={<DigitalDeputee />} />
          <Route path="/financial-services" element={<Financialservices />} />
          <Route path="/education" element={<Education />} />
          <Route path="/healthcare" element={<Healthcare />} />
          <Route path="/energy-utilities" element={<EnergyUtilities />} />
          <Route path="/credit-risk" element={<CreditRisk />} />
          <Route path="/exam-assessment" element={<ExamAssessment />} />
          <Route path="/blood-bank-management" element={<BloodBankManagement />} />
          <Route path="/fact-checking-reports" element={<FactCheckingReports />} />
          <Route path="/financial-crime-monitoring" element={<FinancialCrimeMonitoring />} />
          <Route path="/genai-tutor" element={<GenAITutor />} /> 
          <Route path="/theatre-optimisation" element={<TheatreOptimisation />} />
          <Route path="/generation-forecasting" element={<GenerationForecasting />} />
          <Route path="/news" element={<><News /><Footer /></>} />
          <Route path="*" element={
            <main style={{ minHeight: '60vh', display: 'grid', placeContent: 'center', textAlign: 'center', padding: '4rem 1.5rem' }}>
              <p style={{ color: '#21845b', fontWeight: 700, letterSpacing: '0.12em' }}>404 · PAGE NOT FOUND</p>
              <h1 style={{ margin: '0.75rem 0', color: '#101828' }}>We couldn’t find that page.</h1>
              <p style={{ color: '#667085' }}>The address may be incorrect or the page may have moved.</p>
              <a href="/" style={{ justifySelf: 'center', marginTop: '1.5rem', color: '#176b4b', fontWeight: 700 }}>Return to AIVION home</a>
            </main>
          } />

        </Routes>
      </div>
    </Router>
  );
}


export default App;
